import { guardNumber } from "../numbers";
import type { Nullable } from "../types";

export type CalculatedTime = Pick<
	ReturnType<typeof calculateTimeBySeconds>,
	"hours" | "minutes" | "seconds"
>;

export function calculateTimeBySeconds(_seconds: Nullable<number>) {
	const hours = Math.floor(guardNumber(_seconds) / 3600);
	const minutes = Math.floor((guardNumber(_seconds) % 3600) / 60);
	const seconds = guardNumber(_seconds) % 60;

	return { hours, minutes, seconds };
}
